import { gql } from "@apollo/client"

export const GET_REGIONS = gql`
  query GetRegions {
    regions(sort: ["name:asc"], pagination: { pageSize: 500 }) {
      data {
        id
        attributes {
          name
          slug
        }
      }
    }
  }
`
